import {ToolbarFactory} from "../toolbar-factory.js";

class PlatebniInfo {

	#apiUrl = '/api/v1/prihlaska/platebni-info';


	init(element) {
		this.#addButton(element, () => this.#insertPlatebniInfo(element));
	}

	#addButton(element, buttonCallback) {

		ToolbarFactory.addButton(
			element,
			'<i class="fa-solid fa-money-check-pen"></i> Vložit platební info k přihlášce',
			buttonCallback
		);

	}

	async #getPrihlaskaPlatebniInfo(prihlaskaUid) {
		try {
			const payload = await naja.makeRequest('GET', this.#apiUrl, {
				identifier: prihlaskaUid
			}, {
				history: false
			});

			const prihlaska = new dataObjects.prihlaska(
				payload.variabilniSymbol,
				payload.kurz.uid,
				payload.kurz.id,
				payload.zbyvaUhradit,
				payload.datumSplatnosti
			);

			const datumSplatnosti = new Date();
			datumSplatnosti.setDate(datumSplatnosti.getDate() + 2);

			return 'Platební info k přihlášce:' + '\n' +
				'kurz: ' + payload.kurz.nazev + ' (' + prihlaska.kurzId  + ')' + '\n' +
				'VS: ' + prihlaska.variabilniSymbol + '\n' +
				'splatnost: ' + datumSplatnosti.getDate() + '. ' + (datumSplatnosti.getMonth() + 1) + '.' + '\n' +
				'částka: ' + prihlaska.zbyvaUhradit + '\n' +
				'číslo účtu: ' + payload.cisloUctu;
		} catch (error) {
			console.error('Chyba při načítání platebních informací:', error);
			return 'Nepodařilo se načíst platební informace.';
		}

	}

	async #insertPlatebniInfo(element) {
		const prihlaskaUid = element.dataset.prihlaskaUid;
		if (!prihlaskaUid) {
			return;
		}
		const platebniInfo = await this.#getPrihlaskaPlatebniInfo(prihlaskaUid);

		element.value = platebniInfo;
		element.dispatchEvent(new InputEvent('input', {bubbles: true, cancelable: true}))
	}
};


export default new PlatebniInfo();